import React from "react";
import { FiLink2 } from "react-icons/fi";
import "./Header.css";
// import logo1 from '../assets/img/SE-logo-white.webp'
// import logo2 from "../../public/assets/img/SE-logo.webp";
function Header({ internal }) {
  return (
    <>
      <div className="seh-topbar"></div>
      <div className="thetop" ></div>
      <header className="header-section" style={{background:"white",maxHeight:"80px"}}>
        <nav className="navbar navbar-expand-lg " id="main_navbar">
          <div className="container">
            <div className="seh-brand-wrap">
              <a className="navbar-brand white-logo" href="/">
                <img
                  src={"/assets/img/SE-logo.webp"}
                  alt="Search Education"
                  width="100%"
                />
              </a>
              {/* <a className="navbar-brand color-logo" href="/">
                <img
                  src={"/assets/img/SE-logo.webp"}
                  alt="Search Education"
                  width="100%"
                />
              </a> */}
            </div>
            {/* <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon">
                <i className="fa fa-bars" aria-hidden="true"></i>
              </span>
            </button> */}
            {internal ? (
              <button
                className="seh-alllinks-btn"
                onClick={() => (window.location.href = "/all-links")}
              >
                <FiLink2 size={14} />
                All Links
              </button>
            ) : (
              ""
            )}
          </div>
        </nav>
      </header>
    </>
  );
}
export default Header;
